<div class="mt-5">
  <form (ngSubmit)="ngSubmit()" [formGroup]="formData">
    <div class="baseMainFields">
      <h5 class="text-center">These fields cannot be edited</h5>
      <div class="mainFields d-flex flex-wrap mt-5">
        <div class="mt-4 me-lg-4">
          <label class="tagReq">Resident First Name</label>
          <input
            [readOnly]="created"
            placeholder="Type The Resident Name"
            formControlName="firstName" />
          <div
            class="mt-2"
            *ngIf="submit && form.firstName.errors"
            style="font-size: 80%; color: rgb(244 106 106)">
            <span *ngIf="form.firstName.errors.required"
              >Please provide a valid resident first name.</span
            >
          </div>
        </div>

        <div class="mt-4 ms-xl-5">
          <label class="tagReq">Resident Last Name</label>
          <input
            [readOnly]="created"
            placeholder="Type The Resident Name"
            formControlName="lastName" />
          <div
            class="mt-2"
            *ngIf="submit && form.lastName.errors"
            style="font-size: 80%; color: rgb(244 106 106)">
            <span *ngIf="form.lastName.errors.required"
              >Please provide a valid resident last name.</span
            >
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
